(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acrylic31-artist-acrylic-gallery"] && !Shopify.designMode) return;
  try {
    
function initAcrylicGallery(scope) {
  scope.querySelectorAll('.js-aa60-gallery').forEach(list => {
    if (list.dataset.initialized) return;
    list.dataset.initialized = 'true';
    const items = [...list.querySelectorAll('.aa60-gallery__item')];
    const activate = item => items.forEach(el => {const active = el === item; el.classList.toggle('is-active', active); el.setAttribute('aria-expanded', active);});
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {if (matchMedia('(min-width:1000px)').matches) activate(item);});
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => {if(event.key === 'Enter' || event.key === ' ') {event.preventDefault();activate(item);}});
    });
  });
}
initAcrylicGallery(document);
document.addEventListener('shopify:section:load', event => initAcrylicGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acrylic31-artist-acrylic-highlights"] && !Shopify.designMode) return;
  try {
    
function initAcrylicHighlights(scope) {
  scope.querySelectorAll('[data-aa60-highlights]').forEach(container => {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';
    const root = container.closest('.aa60_scene_graphic_image');
    const items = [...container.querySelectorAll('[data-index]')];
    const media = [...root.querySelectorAll('[data-media-index]')];
    const activate = item => {
      items.forEach(el => { const active = el === item; el.classList.toggle('active', active); el.setAttribute('aria-expanded', active); });
      media.forEach(el => el.classList.toggle('active', el.dataset.mediaIndex === item.dataset.index));
    };
    items.forEach(item => {
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(item); } });
    });
  });
}
initAcrylicHighlights(document);
document.addEventListener('shopify:section:load', event => initAcrylicHighlights(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acrylic31-artist-acrylic-videos"] && !Shopify.designMode) return;
  try {
    
function initAcrylicVideos(scope){
  scope.querySelectorAll('[data-aa60-videos]').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const rail=section.querySelector('.aa60-videos__rail');
    const previous=section.querySelector('.aa60-videos__previous');
    const next=section.querySelector('.aa60-videos__next');
    const state=()=>{previous.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;};
    const pauseAll=()=>section.querySelectorAll('video').forEach(video=>video.pause());
    const move=direction=>{pauseAll();const card=rail.querySelector('.aa60-videos__card');if(!card)return;rail.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',state,{passive:true});
    section.querySelectorAll('.aa60-videos__play').forEach(button=>button.addEventListener('click',()=>{const video=button.nextElementSibling;video.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;delete source.dataset.src;});video.hidden=false;button.hidden=true;video.load();video.play().catch(()=>{});video.focus();}));
    section.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
    const visibility=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.intersectionRatio<0.5)entry.target.querySelector('video')?.pause();}),{threshold:[0,0.5]});
    section.querySelectorAll('.aa60-videos__card').forEach(card=>visibility.observe(card));
    document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseAll();});
    new ResizeObserver(state).observe(rail);
    state();
  });
}
initAcrylicVideos(document);
document.addEventListener('shopify:section:load',event=>initAcrylicVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acrylic31-skin-acrylic-review-gallery"] && !Shopify.designMode) return;
  try {
    
function initSkinAcrylicGallery(scope) {
  scope.querySelectorAll('.js-sa59-gallery').forEach(list => {
    if (list.dataset.initialized) return;
    list.dataset.initialized = 'true';
    const items = [...list.querySelectorAll('.sa59-gallery__item')];
    const activate = item => items.forEach(el => {const active = el === item; el.classList.toggle('is-active', active); el.setAttribute('aria-expanded', active);});
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {if (matchMedia('(min-width:1000px)').matches) activate(item);});
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => {if(event.key === 'Enter' || event.key === ' ') {event.preventDefault();activate(item);}});
    });
  });
}
initSkinAcrylicGallery(document);
document.addEventListener('shopify:section:load', event => initSkinAcrylicGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acrylic31-skin-acrylic-review-highlights"] && !Shopify.designMode) return;
  try {
    
function initSkinAcrylicHighlights(scope) {
  scope.querySelectorAll('[data-sa59-highlights]').forEach(container => {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';
    const root = container.closest('.sa59_scene_graphic_image');
    const items = [...container.querySelectorAll('[data-index]')];
    const media = [...root.querySelectorAll('[data-media-index]')];
    const activate = item => {
      items.forEach(el => { const active = el === item; el.classList.toggle('active', active); el.setAttribute('aria-expanded', active); });
      media.forEach(el => el.classList.toggle('active', el.dataset.mediaIndex === item.dataset.index));
    };
    items.forEach(item => {
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(item); } });
    });
  });
}
initSkinAcrylicHighlights(document);
document.addEventListener('shopify:section:load', event => initSkinAcrylicHighlights(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acrylic31-skin-acrylic-review-videos"] && !Shopify.designMode) return;
  try {
    
function initSkinAcrylicVideos(scope){
  scope.querySelectorAll('[data-sa59-videos]').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const rail=section.querySelector('.sa59-videos__rail');
    const previous=section.querySelector('.sa59-videos__previous');
    const next=section.querySelector('.sa59-videos__next');
    const state=()=>{previous.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;};
    const pauseAll=()=>section.querySelectorAll('video').forEach(video=>video.pause());
    const move=direction=>{pauseAll();const card=rail.querySelector('.sa59-videos__card');if(!card)return;rail.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',state,{passive:true});
    section.querySelectorAll('.sa59-videos__play').forEach(button=>button.addEventListener('click',()=>{const video=button.nextElementSibling;video.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;delete source.dataset.src;});video.hidden=false;button.hidden=true;video.load();video.play().catch(()=>{});video.focus();}));
    section.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
    const visibility=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.intersectionRatio<0.5)entry.target.querySelector('video')?.pause();}),{threshold:[0,0.5]});
    section.querySelectorAll('.sa59-videos__card').forEach(card=>visibility.observe(card));
    document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseAll();});
    new ResizeObserver(state).observe(rail);
    state();
  });
}
initSkinAcrylicVideos(document);
document.addEventListener('shopify:section:load',event=>initSkinAcrylicVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-oil-gallery"] && !Shopify.designMode) return;
  try {
    
function initArtistGallery(scope) {
  scope.querySelectorAll('.js-ao40-gallery').forEach(list => {
    if (list.dataset.initialized) return;
    list.dataset.initialized = 'true';
    const items = [...list.querySelectorAll('.ao40-gallery__item')];
    const activate = item => items.forEach(el => {const active = el === item; el.classList.toggle('is-active', active); el.setAttribute('aria-expanded', active);});
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {if (matchMedia('(min-width:1000px)').matches) activate(item);});
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => {if(event.key === 'Enter' || event.key === ' ') {event.preventDefault();activate(item);}});
    });
  });
}
initArtistGallery(document);
document.addEventListener('shopify:section:load', event => initArtistGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-oil-highlights"] && !Shopify.designMode) return;
  try {
    
function initArtistHighlights(scope) {
  scope.querySelectorAll('[data-ao40-highlights]').forEach(container => {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';
    const root = container.closest('.ao40_scene_graphic_image');
    const items = [...container.querySelectorAll('[data-index]')];
    const media = [...root.querySelectorAll('[data-media-index]')];
    const activate = item => {
      items.forEach(el => { const active = el === item; el.classList.toggle('active', active); el.setAttribute('aria-expanded', active); });
      media.forEach(el => el.classList.toggle('active', el.dataset.mediaIndex === item.dataset.index));
    };
    items.forEach(item => {
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(item); } });
    });
  });
}
initArtistHighlights(document);
document.addEventListener('shopify:section:load', event => initArtistHighlights(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-oil-videos"] && !Shopify.designMode) return;
  try {
    
function initArtistVideos(scope){
  scope.querySelectorAll('[data-ao40-videos]').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const rail=section.querySelector('.ao40-videos__rail');
    const previous=section.querySelector('.ao40-videos__previous');
    const next=section.querySelector('.ao40-videos__next');
    const state=()=>{previous.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;};
    const pauseAll=()=>section.querySelectorAll('video').forEach(video=>video.pause());
    const move=direction=>{pauseAll();const card=rail.querySelector('.ao40-videos__card');if(!card)return;rail.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',state,{passive:true});
    section.querySelectorAll('.ao40-videos__play').forEach(button=>button.addEventListener('click',()=>{const video=button.nextElementSibling;video.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;delete source.dataset.src;});video.hidden=false;button.hidden=true;video.load();video.play().catch(()=>{});video.focus();}));
    section.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
    const visibility=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.intersectionRatio<0.5)entry.target.querySelector('video')?.pause();}),{threshold:[0,0.5]});
    section.querySelectorAll('.ao40-videos__card').forEach(card=>visibility.observe(card));
    document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseAll();});
    new ResizeObserver(state).observe(rail);
    state();
  });
}
initArtistVideos(document);
document.addEventListener('shopify:section:load',event=>initArtistVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-oil-youtube"] && !Shopify.designMode) return;
  try {
    
function initArtistYouTube(scope){scope.querySelectorAll('[data-ao40-youtube]').forEach(player=>{const button=player.querySelector('button');if(!button||button.dataset.initialized)return;button.dataset.initialized='true';button.addEventListener('click',()=>{const iframe=document.createElement('iframe');iframe.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(player.dataset.ao40Youtube)+'?autoplay=1';iframe.title=player.dataset.videoTitle;iframe.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';iframe.allowFullscreen=true;player.replaceChildren(iframe);});});}
initArtistYouTube(document);document.addEventListener('shopify:section:load',event=>initArtistYouTube(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canvas31-creator-videos"] && !Shopify.designMode) return;
  try {
    
function initCanvas31Videos(scope){
  scope.querySelectorAll('[data-canvas31-videos]').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const rail=section.querySelector('.canvas31-videos__rail');
    const previous=section.querySelector('.canvas31-videos__previous');
    const next=section.querySelector('.canvas31-videos__next');
    const state=()=>{previous.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;};
    const pauseAll=()=>section.querySelectorAll('video').forEach(video=>video.pause());
    const move=direction=>{pauseAll();const card=rail.querySelector('.canvas31-videos__card');if(!card)return;rail.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',state,{passive:true});
    section.querySelectorAll('.canvas31-videos__play').forEach(button=>button.addEventListener('click',()=>{const video=button.nextElementSibling;video.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;delete source.dataset.src;});video.hidden=false;button.hidden=true;video.load();video.play().catch(()=>{});video.focus();}));
    section.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
    const visibility=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.intersectionRatio<0.5)entry.target.querySelector('video')?.pause();}),{threshold:[0,0.5]});
    section.querySelectorAll('.canvas31-videos__card').forEach(card=>visibility.observe(card));
    document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseAll();});
    new ResizeObserver(state).observe(rail);
    state();
  });
}
initCanvas31Videos(document);
document.addEventListener('shopify:section:load',event=>initCanvas31Videos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq31-equipment-highlights"] && !Shopify.designMode) return;
  try {
    
function initAcrylicHighlights(scope) {
  scope.querySelectorAll('[data-peq-highlights]').forEach(container => {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';
    const root = container.closest('.peq_scene_graphic_image');
    const items = [...container.querySelectorAll('[data-index]')];
    const media = [...root.querySelectorAll('[data-media-index]')];
    const activate = item => {
      items.forEach(el => { const active = el === item; el.classList.toggle('active', active); el.setAttribute('aria-expanded', active); });
      media.forEach(el => el.classList.toggle('active', el.dataset.mediaIndex === item.dataset.index));
    };
    items.forEach(item => {
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(item); } });
    });
  });
}
initAcrylicHighlights(document);
document.addEventListener('shopify:section:load', event => initAcrylicHighlights(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq31-equipment-videos"] && !Shopify.designMode) return;
  try {
    
function initAcrylicVideos(scope){
  scope.querySelectorAll('[data-peq-videos]').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const rail=section.querySelector('.peq-videos__rail');
    const previous=section.querySelector('.peq-videos__previous');
    const next=section.querySelector('.peq-videos__next');
    const state=()=>{previous.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;};
    const pauseAll=()=>section.querySelectorAll('video').forEach(video=>video.pause());
    const move=direction=>{pauseAll();const card=rail.querySelector('.peq-videos__card');if(!card)return;rail.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',state,{passive:true});
    section.querySelectorAll('.peq-videos__play').forEach(button=>button.addEventListener('click',()=>{const video=button.nextElementSibling;video.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;delete source.dataset.src;});video.hidden=false;button.hidden=true;video.load();video.play().catch(()=>{});video.focus();}));
    section.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
    const visibility=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.intersectionRatio<0.5)entry.target.querySelector('video')?.pause();}),{threshold:[0,0.5]});
    section.querySelectorAll('.peq-videos__card').forEach(card=>visibility.observe(card));
    document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseAll();});
    new ResizeObserver(state).observe(rail);
    state();
  });
}
initAcrylicVideos(document);
document.addEventListener('shopify:section:load',event=>initAcrylicVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eq31-hx3-gallery"] && !Shopify.designMode) return;
  try {
    
function initAcrylicGallery(scope) {
  scope.querySelectorAll('.js-peq-gallery').forEach(list => {
    if (list.dataset.initialized) return;
    list.dataset.initialized = 'true';
    const items = [...list.querySelectorAll('.peq-gallery__item')];
    const activate = item => items.forEach(el => {const active = el === item; el.classList.toggle('is-active', active); el.setAttribute('aria-expanded', active);});
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {if (matchMedia('(min-width:1000px)').matches) activate(item);});
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => {if(event.key === 'Enter' || event.key === ' ') {event.preventDefault();activate(item);}});
    });
  });
}
initAcrylicGallery(document);
document.addEventListener('shopify:section:load', event => initAcrylicGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oil-stick-story"] && !Shopify.designMode) return;
  try {
    
if (document.body.classList.contains('template-product-oil-sticks-marine-12')) {
  let stopAnchorTracking = () => {};
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.anchorTabs_title');
    if (!tab) return;
    const target = document.querySelector('.data-tab-panel[data-tab-key="' + tab.dataset.tab + '"]');
    if (!target) return;
    stopAnchorTracking();
    let previousTop = target.getBoundingClientRect().top + window.scrollY;
    let correction;
    let expiry;
    const stop = () => {
      observer.disconnect();
      clearTimeout(correction);
      clearTimeout(expiry);
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
      window.removeEventListener('keydown', stop);
    };
    const observer = new ResizeObserver(() => {
      const nextTop = target.getBoundingClientRect().top + window.scrollY;
      if (Math.abs(nextTop - previousTop) < 4) return;
      previousTop = nextTop;
      clearTimeout(correction);
      correction = setTimeout(() => {
        const nav = document.querySelector('#anchorTabsContainer');
        const header = document.querySelector('.header-section');
        const announcement = document.querySelector('.announcement-bar-section');
        const announcementHeight = announcement && getComputedStyle(announcement).position === 'sticky' ? announcement.offsetHeight : 0;
        const offset = (nav ? nav.offsetHeight : 0) + (header ? header.offsetHeight : 0) + announcementHeight;
        window.scrollTo({top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset), behavior: 'instant'});
      }, 120);
    });
    observer.observe(document.body);
    window.addEventListener('wheel', stop, {passive: true, once: true});
    window.addEventListener('touchstart', stop, {passive: true, once: true});
    window.addEventListener('keydown', stop, {once: true});
    expiry = setTimeout(stop, 5000);
    stopAnchorTracking = stop;
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-oil-50-gallery"] && !Shopify.designMode) return;
  try {
    
function initStudioGallery(scope) {
  scope.querySelectorAll('.js-so50-gallery').forEach(list => {
    if (list.dataset.initialized) return;
    list.dataset.initialized = 'true';
    const items = [...list.querySelectorAll('.so50-gallery__item')];
    const activate = item => items.forEach(el => {const active = el === item; el.classList.toggle('is-active', active); el.setAttribute('aria-expanded', active);});
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {if (matchMedia('(min-width:1000px)').matches) activate(item);});
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => {if(event.key === 'Enter' || event.key === ' ') {event.preventDefault();activate(item);}});
    });
  });
}
initStudioGallery(document);
document.addEventListener('shopify:section:load', event => initStudioGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-oil-50-highlights"] && !Shopify.designMode) return;
  try {
    
function initStudioHighlights(scope) {
  scope.querySelectorAll('[data-so50-highlights]').forEach(container => {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';
    const root = container.closest('.so50_scene_graphic_image');
    const items = [...container.querySelectorAll('[data-index]')];
    const media = [...root.querySelectorAll('[data-media-index]')];
    const activate = item => {
      items.forEach(el => { const active = el === item; el.classList.toggle('active', active); el.setAttribute('aria-expanded', active); });
      media.forEach(el => el.classList.toggle('active', el.dataset.mediaIndex === item.dataset.index));
    };
    items.forEach(item => {
      item.addEventListener('click', () => activate(item));
      item.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(item); } });
    });
  });
}
initStudioHighlights(document);
document.addEventListener('shopify:section:load', event => initStudioHighlights(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-oil-50-videos"] && !Shopify.designMode) return;
  try {
    
function initStudioVideos(scope){
  scope.querySelectorAll('[data-so50-videos]').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const rail=section.querySelector('.so50-videos__rail');
    const previous=section.querySelector('.so50-videos__previous');
    const next=section.querySelector('.so50-videos__next');
    const state=()=>{previous.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;};
    const move=direction=>{const card=rail.querySelector('.so50-videos__card');if(!card)return;rail.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',state,{passive:true});
    section.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
    new ResizeObserver(state).observe(rail);
    state();
  });
}
initStudioVideos(document);
document.addEventListener('shopify:section:load',event=>initStudioVideos(event.target));

  } catch(e) { console.error(e); }
})();
})();
